/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useMemo, useRef, useState} from 'react'
import Slider from 'rc-slider'
import 'rc-slider/assets/index.css'
import './NewPurchaseCreditModal.scss'
import {useDispatch, useSelector} from 'react-redux'
import Promocodepopup from './modal/Promocodepopup'
import SmsMmsPopup from './modal/SmsMmsPopup'
import CardPaymentPopup from './modal/CardPaymentPopup'
import {Elements} from '@stripe/react-stripe-js'
import {GetProductList} from '../../Redux/AdminPanel/PurchaseCreditSlice'
import {GeneralDataOFLoginUser} from '../../Utils/Auth'
import PriceViewPopup from './modal/PriceViewPopup'
import StripeJSProvider from '../../Utils/StripeJSProvider'
import clsx from 'clsx'

import {
  FeGetPriceRuleList,
} from '../AdminPages/Setup/GlobalRateCard/GlobalRateCardSlice/GlobalRateCardSlice'

import {usePricingRulesMutation} from '../../../services/cellcast.v3'
import {CampType, PaymentPricingRules} from '../../../services/cellcast.v3.types'
import {getIsDefaultRegion, getDefaultRegion} from '../UserPages/accounts/Overview/OverviewSlice/UserDetailsSlice'
import { REGION } from '../../Utils/Constant/ConstantForWebsite'

const NewPurchaseCreditModal = () => {
  const maxCredit = 200000
  const minCredit = 20
  const dispatch = useDispatch()
  const accountId = GeneralDataOFLoginUser()?.user?.accountId
  const purchaseCreditInputref: any = useRef()
  const [card, setCard] = useState(false)
  const [noOfCredit, setNoOFCredit] = useState<any>(0)
  const [quickSms, setQuickSms] = useState('sms')
  const [checkBox, setCheckBox] = useState(false)
  const [viewPricePopup, setViewPricePopup] = useState(false)
  const [price, setPrice] = useState(0)
  const [discount, setDiscount] = useState<any>(0)
  const [couponId, setCouponId] = useState('')
  const [error, setError] = useState('')
  const [leastPrice, setleastPrice] = useState<any>(20)
  const [showContactInfo, setShowContactInfo] = useState<any>(false)
  const userData: any = GeneralDataOFLoginUser()?.globalSettingData?.[0]?.value
  const [promocodePopup, setPromocodePopup] = useState<any>(false)
  const ApplyPromoCode = useMemo(
    () => (
      <Promocodepopup
        setDiscount={setDiscount}
        setCouponId={setCouponId}
        checkBox={checkBox}
        price={price}
        noOfCredit={noOfCredit}
        show={promocodePopup}
        handleClose={() => setPromocodePopup(false)}
      />
    ),
    [promocodePopup]
  )

  const isDefaultRegion = useSelector(getIsDefaultRegion)
  const userRegion = useSelector(getDefaultRegion)

  const restAllData = () => {
    setDiscount(0)
    setCheckBox(false)
    setCard(false)
    setCouponId('')
    setPrice(0)
    setNoOFCredit(0)
  }
  const handleChange = (event: any) => {
    if (!isNaN(event)) {
      setNoOFCredit(event.trim())
    }
  }
  const handleNumberConvert = (val: any) => {
    const data: any = new Intl.NumberFormat('en-US').format(val)
    return data
  }
  const handleError = (value: any) => {
    const minCredits =
      quickSms == 'sms'
        ? Number(userData?.MIN_PURCHASES_SMS_CERDIT ?? 20)
        : Number(userData?.MIN_PURCHASES_MMS_CERDIT ?? 20)

    var n = Math.floor(Number(value))
    if (isNaN(+value)) {
      setError('Credit must be Integer')
      return
    }
    if (!(+value <= +maxCredit)) {
      setError(`Credit should be less than max ${maxCredit}`)
      return
    }
    if (!(+value >= +minCredits)) {
      setError(
        `Credit must be greater than ${
          quickSms === 'sms'
            ? Number(userData?.MIN_PURCHASES_SMS_CERDIT ?? 20)
            : Number(userData?.MIN_PURCHASES_MMS_CERDIT ?? 20)
        }`
      )
      return
    }
    if (value <= maxCredit && value >= minCredit) {
      setError('')
      return
    }
  }

  const [pricingRules, {data: RateCardList}] = usePricingRulesMutation()

  const [smsdetailpopup, setsmsdetailpopup] = useState<any>(false)
  const ApplysmsPopup = useMemo(
    () => <SmsMmsPopup show={smsdetailpopup} handleClose={() => setsmsdetailpopup(false)} />,
    [smsdetailpopup]
  )

  const getPricingRules = () => {
    if (isDefaultRegion && accountId) {
      dispatch(FeGetPriceRuleList({accountId: accountId}))
      return
    }

    pricingRules({
      action: 'find_pricing_rules',
      data: {
        accountId: accountId,
      },
    })
  }
  useEffect(() => {
    dispatch(GetProductList())
    getPricingRules()
    purchaseCreditInputref?.current?.focus()
  }, [])

  const defaultRegionPriceListSMS = useSelector(
    (state: any) => state?.priceRules?.RateCardList
  )?.filter((key: any) => key?.type === 'SMS')
  const defaultRegionPriceListMMS = useSelector(
    (state: any) => state?.priceRules?.RateCardList
  )?.filter((key: any) => key?.type === 'MMS')

  const otherRegionPriceListSMS = RateCardList?.data?.filter(
    (key: PaymentPricingRules) => key?.Type === CampType.sms.toUpperCase()
  )
  const otherRegionPriceListMMS = RateCardList?.data?.filter(
    (key: PaymentPricingRules) => key?.Type === CampType.mms.toUpperCase()
  )

  const PriceRateListSMS = isDefaultRegion ? defaultRegionPriceListSMS : otherRegionPriceListSMS
  const PriceRateListMMS = isDefaultRegion ? defaultRegionPriceListMMS : otherRegionPriceListMMS

  useEffect(() => {
    /** Other Region */
    if (!isDefaultRegion) {
      if (quickSms === CampType.sms) {
        let leastRate = PriceRateListSMS?.find(
          (key: PaymentPricingRules) =>
            key?.CreditEndRange >= +minCredit && key?.CreditStartRange <= +minCredit
        )?.FinalPrice
        setleastPrice(leastRate)
      } else {
        let leastRate = PriceRateListMMS?.find(
          (key: PaymentPricingRules) =>
            key?.CreditEndRange >= +minCredit && key?.CreditStartRange <= +minCredit
        )?.FinalPrice
        setleastPrice(leastRate)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quickSms, minCredit])

  useEffect(() => {
    /** Default Region */
    if (isDefaultRegion) {
      if (quickSms === 'sms') {
        let leastRate = PriceRateListSMS?.find(
          (key: any) => key?.creditendrange >= +minCredit && key?.creditstartrange <= +minCredit
        )?.finalPrice
        setleastPrice(leastRate)
      } else {
        let leastRate = PriceRateListMMS?.find(
          (key: any) => key?.creditendrange >= +minCredit && key?.creditstartrange <= +minCredit
        )?.finalPrice
        setleastPrice(leastRate)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quickSms, minCredit])

  useEffect(() => {
    /** Other region */
    if (!isDefaultRegion) {
      if (quickSms === CampType.sms) {
        let price =
          PriceRateListSMS?.find(
            (key: PaymentPricingRules) =>
              key?.CreditEndRange >= +noOfCredit && key?.CreditStartRange <= +noOfCredit
          ) === undefined
            ? // ? PriceRateListSMS?.[PriceRateListSMS?.length - 1]?.finalPrice
              PriceRateListSMS?.find(
                (key: PaymentPricingRules) =>
                  key?.CreditEndRange ===
                  Math.max(...PriceRateListSMS.map((o: PaymentPricingRules) => o?.CreditEndRange))
              )?.FinalPrice
            : PriceRateListSMS?.find(
                (key: PaymentPricingRules) =>
                  key?.CreditEndRange >= +noOfCredit && key?.CreditStartRange <= +noOfCredit
              )?.FinalPrice
        setPrice(price as number)
      } else {
        let price =
          PriceRateListMMS?.find(
            (key: PaymentPricingRules) =>
              key?.CreditEndRange >= +noOfCredit && key?.CreditStartRange <= +noOfCredit
          ) === undefined
            ? // ? PriceRateListMMS?.[PriceRateListMMS?.length - 1]?.finalPrice
              PriceRateListMMS?.find(
                (key: PaymentPricingRules) =>
                  key?.CreditEndRange ===
                  Math.max(...PriceRateListMMS.map((o: PaymentPricingRules) => o?.CreditEndRange))
              )?.FinalPrice
            : PriceRateListMMS?.find(
                (key: PaymentPricingRules) =>
                  key?.CreditEndRange >= +noOfCredit && key?.CreditStartRange <= +noOfCredit
              )?.FinalPrice
        setPrice(price as number)
      }

      if (noOfCredit > 100000) {
        setShowContactInfo(true)
      } else {
        setShowContactInfo(false)
      }
    }
  }, [quickSms, noOfCredit, PriceRateListSMS, PriceRateListMMS])

  useEffect(() => {
    /** Default region */
    if (isDefaultRegion) {
      if (quickSms === 'sms') {
        let price =
          PriceRateListSMS?.find(
            (key: any) => key?.creditendrange >= +noOfCredit && key?.creditstartrange <= +noOfCredit
          ) == undefined
            ? // ? PriceRateListSMS?.[PriceRateListSMS?.length - 1]?.finalPrice
              PriceRateListSMS?.find(
                (key: any) =>
                  key?.creditendrange ===
                  Math.max(...PriceRateListSMS.map((o: any) => o?.creditendrange))
              )?.finalPrice
            : PriceRateListSMS?.find(
                (key: any) =>
                  key?.creditendrange >= +noOfCredit && key?.creditstartrange <= +noOfCredit
              )?.finalPrice
        setPrice(price as number)
      } else {
        let price =
          PriceRateListMMS?.find(
            (key: any) => key?.creditendrange >= +noOfCredit && key?.creditstartrange <= +noOfCredit
          ) == undefined
            ? // ? PriceRateListMMS?.[PriceRateListMMS?.length - 1]?.finalPrice
              PriceRateListMMS?.find(
                (key: any) =>
                  key?.creditendrange ===
                  Math.max(...PriceRateListMMS.map((o: any) => o?.creditendrange))
              )?.finalPrice
            : PriceRateListMMS?.find(
                (key: any) =>
                  key?.creditendrange >= +noOfCredit && key?.creditstartrange <= +noOfCredit
              )?.finalPrice
        setPrice(price as number)
      }

      if (noOfCredit > 100000) {
        setShowContactInfo(true)
      } else {
        setShowContactInfo(false)
      }
    }
  }, [quickSms, noOfCredit, PriceRateListSMS, PriceRateListMMS])

  const sliderShow = useMemo(
    () => (
      <Slider
        // defaultValue={50000}
        value={noOfCredit}
        min={20}
        max={200000}
        step={1}
        marks={{0: '0', 200000: '200000'}}
        onChange={(e: any) => {
          if (discount !== 0) {
            setNoOFCredit(e)
            setDiscount(0)
            handleError(e)
          } else {
            setNoOFCredit(e)
            handleError(e)
          }
        }}
        style={{width: '80%'}}
      />
    ),
    [noOfCredit]
  )

  const viewPriceModel = useMemo(
    () => <PriceViewPopup show={viewPricePopup} handleClose={() => setViewPricePopup(false)} />,
    [viewPricePopup]
  )

  return (
    <div>
      {ApplyPromoCode}
      {ApplysmsPopup}
      {viewPriceModel}
      <div className='card select-credit'>
        <div className='row m-0'>
          <div className='col-lg-7 py-5 px-10 pb-10'>
            <div className='card-header border-0 my-3 mb-8 p-0'>
              <div className='card-title align-items-start flex-column mb-1'>
                <span className='card-label fw-bolder fs-4'>Select your quantity of credits </span>
              </div>
              <p className='text-muted'>
                The more you buy the CHEAPER the credits gets, and they never expire! If you still
                need more info, visit our{' '}
                <a
                  onClick={() => setViewPricePopup(true)}
                  className='text-underline cursor-pointer'
                >
                  visit our full pricing table
                </a>
              </p>
            </div>

            <div className='credit-purchase'>
              <h5 className='mb-5'>
                What type of credits would you like to purchase?{' '}
                <a href='#' onClick={() => setsmsdetailpopup(true)} className='ms-1'>
                  <svg
                    width='16'
                    height='16'
                    viewBox='0 0 16 16'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      opacity='0.3'
                      d='M8 15.5C12.1421 15.5 15.5 12.1421 15.5 8C15.5 3.85786 12.1421 0.5 8 0.5C3.85786 0.5 0.5 3.85786 0.5 8C0.5 12.1421 3.85786 15.5 8 15.5Z'
                      fill='#838492'
                    />
                    <path
                      d='M8 10.2497C7.85081 10.2497 7.70774 10.1904 7.60225 10.0849C7.49676 9.97945 7.4375 9.83638 7.4375 9.68719V9.07219C7.4305 8.69625 7.52949 8.32593 7.72314 8.00362C7.9168 7.68131 8.19728 7.42003 8.5325 7.24969C8.72899 7.15461 8.89643 7.00865 9.01744 6.82698C9.13845 6.64531 9.20862 6.43455 9.22064 6.2166C9.23266 5.99864 9.18611 5.78144 9.08581 5.58756C8.98552 5.39368 8.83514 5.23019 8.6503 5.11408C8.46546 4.99796 8.25291 4.93345 8.03471 4.92725C7.81651 4.92106 7.60063 4.97339 7.4095 5.07883C7.21837 5.18427 7.05895 5.33895 6.94781 5.52683C6.83667 5.7147 6.77787 5.92891 6.7775 6.14719C6.7775 6.29638 6.71823 6.43945 6.61274 6.54494C6.50726 6.65043 6.36418 6.70969 6.215 6.70969C6.06581 6.70969 5.92274 6.65043 5.81725 6.54494C5.71176 6.43945 5.6525 6.29638 5.6525 6.14719C5.65375 5.80373 5.73012 5.46469 5.87624 5.15386C6.02237 4.84303 6.23472 4.56792 6.4984 4.34783C6.76208 4.12773 7.07072 3.96798 7.40267 3.87977C7.73461 3.79156 8.08184 3.77703 8.42 3.83719C8.89211 3.92601 9.32594 4.15664 9.66361 4.49834C10.0013 4.84004 10.2268 5.27656 10.31 5.74969C10.4046 6.25535 10.3294 6.7781 10.0961 7.23658C9.8628 7.69506 9.48447 8.06355 9.02 8.28469C8.87783 8.36211 8.75985 8.47735 8.6791 8.61766C8.59836 8.75796 8.558 8.91787 8.5625 9.07969V9.69469C8.56052 9.84257 8.50039 9.98373 8.39512 10.0876C8.28984 10.1915 8.14789 10.2497 8 10.2497Z'
                      fill='#838492'
                    />
                    <path
                      d='M7.99999 12.1924C8.31065 12.1924 8.56249 11.9405 8.56249 11.6299C8.56249 11.3192 8.31065 11.0674 7.99999 11.0674C7.68933 11.0674 7.43749 11.3192 7.43749 11.6299C7.43749 11.9405 7.68933 12.1924 7.99999 12.1924Z'
                      fill='#7950F2'
                    />
                  </svg>
                </a>
              </h5>

              <ul className='nav nav-tabs'>
                <li className='nav-item me-3 mb-3'>
                  <button
                    className={`nav-link btn btn-outline btn-outline-dashed btn-outline-default w-100 p-4 px-6 ${
                      quickSms === 'sms' && 'active'
                    }`}
                    onClick={(e: any) => {
                      setError('')
                      if (discount !== 0) {
                        setQuickSms(CampType.sms)
                        setDiscount(0)
                      } else {
                        setQuickSms(CampType.sms)
                      }
                    }}
                  >
                    SMS
                  </button>
                </li>
                <li className={clsx('nav-item me-3 mb-3', {'d-none': !isDefaultRegion && ![REGION.US, REGION.UK].includes(userRegion)})}>
                  <button
                    className={`nav-link btn btn-outline btn-outline-dashed btn-outline-default w-100 p-4 px-6 ${
                      !(quickSms === 'sms') && 'active'
                    }`}
                    onClick={(e: any) => {
                      setError('')
                      if (discount !== 0) {
                        setQuickSms(CampType.mms)
                        setDiscount(0)
                      } else {
                        setQuickSms(CampType.mms)
                      }
                    }}
                  >
                    MMS
                  </button>
                </li>
              </ul>

              <div className='tab-content' id='myTabContent'>
                <div
                  className='tab-pane fade active show'
                  id='Now'
                  role='tabpanel'
                  aria-labelledby='Now-tab'
                >
                  <h5>How many messages would you like to buy?</h5>
                  <div className='credit-box'>
                    <div className='box-inner'>
                      <label>Credits</label>
                      <input
                        ref={purchaseCreditInputref}
                        maxLength={maxCredit.toString().length + 1}
                        type='text'
                        value={new Intl.NumberFormat('en-US').format(+noOfCredit)}
                        onChange={(e: any) => {
                          let val = e.target.value?.replace(/,/g, '')

                          if (discount !== 0) {
                            handleChange(val)
                            setDiscount(0)
                            handleError(val)
                          } else {
                            handleChange(val)
                            handleError(val)
                          }
                        }}
                      />
                      <span className='text-danger'>{error}</span>
                      <p>
                        1 credit = 1 Message ({quickSms == 'sms' ? 165 : 1000} characters max)
                        Credits never expire
                      </p>
                    </div>
                  </div>

                  {/* {sliderShow} */}

                  {/* <div className='form-check form-check-sm form-check-custom form-check-solid'>
                    <input
                      className='form-check-input me-5'
                      id='stagger'
                      type='checkbox'
                      checked={checkBox}
                      onChange={(e: any) => {
                        if (discount !== 0) {
                          setCheckBox(!checkBox)
                          setDiscount(0)
                        } else {
                          setCheckBox(!checkBox)
                        }
                      }}
                    />
                    <div>
                      <label htmlFor='stagger'>
                        I will send with my Business name or my number (+30% )
                        <a href='#' className='ms-2'>
                          <svg
                            width='16'
                            height='16'
                            viewBox='0 0 16 16'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                          >
                            <path
                              opacity='0.3'
                              d='M8 15.5C12.1421 15.5 15.5 12.1421 15.5 8C15.5 3.85786 12.1421 0.5 8 0.5C3.85786 0.5 0.5 3.85786 0.5 8C0.5 12.1421 3.85786 15.5 8 15.5Z'
                              fill='#838492'
                            />
                            <path
                              d='M8 10.2497C7.85081 10.2497 7.70774 10.1904 7.60225 10.0849C7.49676 9.97945 7.4375 9.83638 7.4375 9.68719V9.07219C7.4305 8.69625 7.52949 8.32593 7.72314 8.00362C7.9168 7.68131 8.19728 7.42003 8.5325 7.24969C8.72899 7.15461 8.89643 7.00865 9.01744 6.82698C9.13845 6.64531 9.20862 6.43455 9.22064 6.2166C9.23266 5.99864 9.18611 5.78144 9.08581 5.58756C8.98552 5.39368 8.83514 5.23019 8.6503 5.11408C8.46546 4.99796 8.25291 4.93345 8.03471 4.92725C7.81651 4.92106 7.60063 4.97339 7.4095 5.07883C7.21837 5.18427 7.05895 5.33895 6.94781 5.52683C6.83667 5.7147 6.77787 5.92891 6.7775 6.14719C6.7775 6.29638 6.71823 6.43945 6.61274 6.54494C6.50726 6.65043 6.36418 6.70969 6.215 6.70969C6.06581 6.70969 5.92274 6.65043 5.81725 6.54494C5.71176 6.43945 5.6525 6.29638 5.6525 6.14719C5.65375 5.80373 5.73012 5.46469 5.87624 5.15386C6.02237 4.84303 6.23472 4.56792 6.4984 4.34783C6.76208 4.12773 7.07072 3.96798 7.40267 3.87977C7.73461 3.79156 8.08184 3.77703 8.42 3.83719C8.89211 3.92601 9.32594 4.15664 9.66361 4.49834C10.0013 4.84004 10.2268 5.27656 10.31 5.74969C10.4046 6.25535 10.3294 6.7781 10.0961 7.23658C9.8628 7.69506 9.48447 8.06355 9.02 8.28469C8.87783 8.36211 8.75985 8.47735 8.6791 8.61766C8.59836 8.75796 8.558 8.91787 8.5625 9.07969V9.69469C8.56052 9.84257 8.50039 9.98373 8.39512 10.0876C8.28984 10.1915 8.14789 10.2497 8 10.2497Z'
                              fill='#838492'
                            />
                            <path
                              d='M7.99999 12.1924C8.31065 12.1924 8.56249 11.9405 8.56249 11.6299C8.56249 11.3192 8.31065 11.0674 7.99999 11.0674C7.68933 11.0674 7.43749 11.3192 7.43749 11.6299C7.43749 11.9405 7.68933 12.1924 7.99999 12.1924Z'
                              fill='#7950F2'
                            />
                          </svg>
                        </a>
                      </label>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>

          <div className='col-lg-5 pe-0'>
            <div className='select-quantity'>
              {noOfCredit <= 0 ? (
                <div className='quantity-top'>
                  <span className='icon'>
                    <svg
                      width='61'
                      height='38'
                      viewBox='0 0 61 38'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M57.75 21.625C59.1307 21.625 60.25 20.5057 60.25 19.125C60.25 17.7443 59.1307 16.625 57.75 16.625V21.625ZM1.63848 17.3572C0.662172 18.3335 0.662172 19.9165 1.63848 20.8928L17.5484 36.8027C18.5247 37.779 20.1076 37.779 21.0839 36.8027C22.0602 35.8264 22.0602 34.2434 21.0839 33.2671L6.94178 19.125L21.0839 4.98286C22.0602 4.00655 22.0602 2.42364 21.0839 1.44733C20.1076 0.47102 18.5247 0.47102 17.5484 1.44733L1.63848 17.3572ZM57.75 16.625H3.40625V21.625H57.75V16.625Z'
                        fill='#7950F2'
                      />
                    </svg>
                  </span>
                  <h5>Select your quantity</h5>
                  <p>Use the slider or type how many message credits you want to send.</p>
                </div>
              ) : (
                <>
                  {showContactInfo && (
                    <>
                      <div className='Notification-msg'>
                        <svg
                          width='17'
                          height='18'
                          viewBox='0 0 17 18'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <circle cx='8.5' cy='9' r='8.5' fill='#FDE5AC' />
                          <path d='M8.5 5.5V11' stroke='#FAC04C' stroke-linecap='round' />
                          <circle cx='8.5' cy='13' r='0.5' fill='#FAC04C' />
                        </svg>

                        <p>
                          Need better pricing? Contact your account manager or{' '}
                          <a href='mailto:info@cellcast.com.au'>info@cellcast.com.au</a>
                        </p>
                      </div>
                    </>
                  )}
                  <div className='credit_edited'>
                    <div className='edited_head'>
                      {!checkBox ? (
                        <h3>${handleNumberConvert((+noOfCredit * +price).toFixed(2))}</h3>
                      ) : (
                        <h3>
                          $
                          {handleNumberConvert(
                            (Math.ceil(+noOfCredit + +noOfCredit * 0.3) * +price).toFixed(2)
                          )}
                        </h3>
                      )}

                      <span>{price}/credit</span>
                    </div>

                    <div className='credit_table'>
                      <table>
                        <tbody>
                          <tr>
                            <td>{quickSms.toLocaleUpperCase()} Credits</td>
                            {!checkBox ? (
                              <td>{handleNumberConvert(Math.ceil(noOfCredit))}</td>
                            ) : (
                              <td>
                                {handleNumberConvert(Math.ceil(+noOfCredit + +noOfCredit * 0.3))}
                              </td>
                            )}
                          </tr>
                          <tr>
                            <td>Cost per credit</td>
                            <td>
                              {discount === 0 && leastPrice > price && <span>{leastPrice}</span>}{' '}
                              {discount !== 0 && <span>{price}</span>}{' '}
                              {discount !== 0
                                ? (price * ((100 - discount) / 100)).toFixed(2)
                                : price}
                            </td>
                          </tr>
                          {discount !== 0 && (
                            <tr>
                              <td>Discount percentage </td>
                              <td>{discount}%</td>
                            </tr>
                          )}
                        </tbody>
                        <tfoot>
                          <tr>
                            <td>GST </td>
                            {!checkBox ? (
                              <td>
                                ${handleNumberConvert((+noOfCredit * +price * 0.1).toFixed(2))}
                              </td>
                            ) : (
                              <td>
                                $
                                {handleNumberConvert(
                                  (
                                    Math.ceil(+noOfCredit + +noOfCredit * 0.3) *
                                    +price *
                                    0.1
                                  ).toFixed(2)
                                )}
                              </td>
                            )}
                          </tr>
                          <tr>
                            <td>Total</td>
                            {!checkBox ? (
                              <td>
                                $
                                {handleNumberConvert(
                                  (+noOfCredit * +price * ((100 - discount) / 100) * 1.1).toFixed(2)
                                )}
                              </td>
                            ) : (
                              <td>
                                $
                                {handleNumberConvert(
                                  (
                                    Math.ceil((+noOfCredit + +noOfCredit * 0.3) * +price) *
                                    ((100 - discount) / 100) *
                                    1.1
                                  ).toFixed(2)
                                )}
                              </td>
                            )}
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                </>
              )}
              <div className='quantity-bottom'>
                <button
                  disabled={noOfCredit <= 0 || error !== ''}
                  className={`${noOfCredit <= 0 ? 'checkout-btn' : 'CreditButton'}`}
                  onClick={() => setCard(true)}
                >
                  Checkout
                </button>
                <span className='coupon'>
                  Have a coupon code?{' '}
                  <a href='#' onClick={() => setPromocodePopup(true)}>
                    Add here
                  </a>
                </span>
                <StripeJSProvider>
                  {({stripe}: any) =>
                    stripe ? (
                      <Elements stripe={stripe}>
                        <CardPaymentPopup
                          restData={() => restAllData()}
                          show={card}
                          handleClose={() => {
                            setCard(false)
                            setDiscount(0)
                            setCheckBox(false)
                            setCard(false)
                            setCouponId('')
                            setPrice(0)
                            setNoOFCredit(0)
                          }}
                          customData={{
                            priceperItems: price,
                            type: quickSms,
                            credits: !checkBox
                              ? +noOfCredit
                              : Math.ceil(+noOfCredit + +noOfCredit * 0.3),
                          }}
                          couponId={couponId}
                        />
                      </Elements>
                    ) : null
                  }
                </StripeJSProvider>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='card py-5 px-10'>
        <div className='card-header border-0 my-3 mb-8 p-0 d-block'>
          <div className='card-title align-items-start flex-column mb-3'>
            <span className='card-label fw-bolder fs-4'>Frequently Asked Questions</span>
          </div>
          <p className='text-muted'>
            Explore our FAQ section for quick answers on pricing, and more. Need further assistance?
            Our support team is here to help!
          </p>

          <div className='row question_box'>
            <div className='col-lg-12'>
              <h5>Pricing</h5>

              <div className='accordion' id='accordionExample'>
                <div className='accordion-item'>
                  <h2 className='accordion-header' id='headingOne'>
                    <button
                      className='accordion-button'
                      type='button'
                      data-bs-toggle='collapse'
                      data-bs-target='#collapseOne'
                      aria-expanded='true'
                      aria-controls='collapseOne'
                    >
                      What is the value of one SMS credit at Cellcast?
                    </button>
                  </h2>
                  <div
                    id='collapseOne'
                    className='accordion-collapse collapse show'
                    aria-labelledby='headingOne'
                    data-bs-parent='#accordionExample'
                  >
                    <div className='accordion-body'>
                      One credit equals 160 characters. When composing messages, you will see a
                      character count for reference. Note that using a Custom ID or Dedicated number
                      incurs a charge of 1.3 credits per message.
                    </div>
                  </div>
                </div>
                <div className='accordion-item'>
                  <h2 className='accordion-header' id='headingTwo'>
                    <button
                      className='accordion-button collapsed'
                      type='button'
                      data-bs-toggle='collapse'
                      data-bs-target='#collapseTwo'
                      aria-expanded='false'
                      aria-controls='collapseTwo'
                    >
                      What is the value of one MMS at Cellcast?
                    </button>
                  </h2>
                  <div
                    id='collapseTwo'
                    className='accordion-collapse collapse'
                    aria-labelledby='headingTwo'
                    data-bs-parent='#accordionExample'
                  >
                    <div className='accordion-body'>
                      At Cellcast, one MMS allows you to send up to 1500 characters along with a
                      massive 800kb media content such as images, videos, or audio. This makes MMS a
                      versatile option for richer, more engaging communications.
                    </div>
                  </div>
                </div>
                <div className='accordion-item'>
                  <h2 className='accordion-header' id='headingThree'>
                    <button
                      className='accordion-button collapsed'
                      type='button'
                      data-bs-toggle='collapse'
                      data-bs-target='#collapseThree'
                      aria-expanded='false'
                      aria-controls='collapseThree'
                    >
                      Do my credits expire?
                    </button>
                  </h2>
                  <div
                    id='collapseThree'
                    className='accordion-collapse collapse'
                    aria-labelledby='headingThree'
                    data-bs-parent='#accordionExample'
                  >
                    <div className='accordion-body'>
                      No, credits purchased for Cellcast services do not expire. You can use your
                      credits at any time without worrying about time constraints.
                    </div>
                  </div>
                </div>
                <div className='accordion-item'>
                  <h2 className='accordion-header' id='headingFour'>
                    <button
                      className='accordion-button collapsed'
                      type='button'
                      data-bs-toggle='collapse'
                      data-bs-target='#collapseFour'
                      aria-expanded='false'
                      aria-controls='collapseFour'
                    >
                      How does Cellcast pricing work?
                    </button>
                  </h2>
                  <div
                    id='collapseFour'
                    className='accordion-collapse collapse'
                    aria-labelledby='headingFour'
                    data-bs-parent='#accordionExample'
                  >
                    <div className='accordion-body'>
                      Cellcast offers a wholesale pricing model where you can buy credits in
                      bundles. The larger the bundle, the lower the cost per message, allowing for
                      significant savings. Additionally, these credits never expire, ensuring you
                      can use them at your convenience without any time constraints.
                    </div>
                  </div>
                </div>
                <div className='accordion-item'>
                  <h2 className='accordion-header' id='headingFive'>
                    <button
                      className='accordion-button collapsed'
                      type='button'
                      data-bs-toggle='collapse'
                      data-bs-target='#collapseFive'
                      aria-expanded='false'
                      aria-controls='collapseFive'
                    >
                      Does it cost to receive replies or inbound messages at Cellcast?
                    </button>
                  </h2>
                  <div
                    id='collapseFive'
                    className='accordion-collapse collapse'
                    aria-labelledby='headingFive'
                    data-bs-parent='#accordionExample'
                  >
                    <div className='accordion-body'>
                      No, receiving replies or inbound messages at Cellcast is completely free.
                    </div>
                  </div>
                </div>
                <div className='accordion-item'>
                  <h2 className='accordion-header' id='headingSix'>
                    <button
                      className='accordion-button collapsed'
                      type='button'
                      data-bs-toggle='collapse'
                      data-bs-target='#collapseSix'
                      aria-expanded='false'
                      aria-controls='collapseSix'
                    >
                      What are the benefits of a dedicated number, and how much does it cost?
                    </button>
                  </h2>
                  <div
                    id='collapseSix'
                    className='accordion-collapse collapse'
                    aria-labelledby='headingSix'
                    data-bs-parent='#accordionExample'
                  >
                    <div className='accordion-body'>
                      Dedicated numbers are a premium messaging option at Cellcast, costing $18 AUD
                      per month or $169 AUD per year. These numbers are exclusive to you, enhancing
                      recipient recognition of your messages. The benefits include increased
                      professionalism, branding, personalisation, security, control, and regulatory
                      compliance. Furthermore, dedicated numbers are less likely to be flagged as
                      spam due to their association with legitimate businesses or organisations. You
                      can purchase these numbers directly on our platform.
                    </div>
                  </div>
                </div>
                <div className='accordion-item'>
                  <h2 className='accordion-header' id='headingSeven'>
                    <button
                      className='accordion-button collapsed'
                      type='button'
                      data-bs-toggle='collapse'
                      data-bs-target='#collapseSeven'
                      aria-expanded='false'
                      aria-controls='collapseSeven'
                    >
                      What is the cost difference between sending SMS via a shared number, dedicated
                      number, and Custom ID at Cellcast?
                    </button>
                  </h2>
                  <div
                    id='collapseSeven'
                    className='accordion-collapse collapse'
                    aria-labelledby='headingSeven'
                    data-bs-parent='#accordionExample'
                  >
                    <div className='accordion-body'>
                      Sending an SMS via a shared number costs 1 credit for every 160 characters. If
                      you use a dedicated number or a Custom ID, the cost increases to 1.3 credits
                      for the same number of characters. This higher cost reflects the additional
                      benefits of using a dedicated number or Custom ID, such as enhanced branding
                      and recognition.
                    </div>
                  </div>
                </div>
                <div className='accordion-item'>
                  <h2 className='accordion-header' id='headingEight'>
                    <button
                      className='accordion-button collapsed'
                      type='button'
                      data-bs-toggle='collapse'
                      data-bs-target='#collapseEight'
                      aria-expanded='false'
                      aria-controls='collapseEight'
                    >
                      What if I want to purchase more than 100,000 credits at Cellcast?
                    </button>
                  </h2>
                  <div
                    id='collapseEight'
                    className='accordion-collapse collapse'
                    aria-labelledby='headingEight'
                    data-bs-parent='#accordionExample'
                  >
                    <div className='accordion-body'>
                      If you're interested in purchasing more than 100,000 credits, please contact
                      us at support@cellcast.com for custom pricing. Our team will provide you with
                      tailored solutions and competitive rates to meet your large-scale messaging
                      needs.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='help'>
            <svg
              width='25'
              height='31'
              viewBox='0 0 25 31'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                opacity='0.3'
                d='M9.36459 28.9605L2.67084 23.4917C2.09846 23.0295 1.63648 22.4452 1.31859 21.7817C1.0007 21.1182 0.834923 20.3921 0.833344 19.6563V8.93757C0.833884 7.98533 1.10942 7.05352 1.62683 6.25412C2.14424 5.45472 2.8815 4.82176 3.75001 4.43132L10.4583 1.36882C11.1037 1.07367 11.805 0.920898 12.5146 0.920898C13.2242 0.920898 13.9255 1.07367 14.5708 1.36882L21.25 4.43132C22.1185 4.82176 22.8558 5.45472 23.3732 6.25412C23.8906 7.05352 24.1661 7.98533 24.1667 8.93757V19.6563C24.1669 20.3909 24.0033 21.1163 23.688 21.7797C23.3727 22.4432 22.9135 23.028 22.3438 23.4917L15.65 28.9605C14.7661 29.692 13.6547 30.0923 12.5073 30.0923C11.3599 30.0923 10.2485 29.692 9.36459 28.9605Z'
                fill='#7950F2'
              />
              <path
                d='M15.4167 19.4378C15.2763 19.4393 15.1371 19.413 15.0069 19.3604C14.8768 19.3079 14.7583 19.2301 14.6583 19.1316L8.825 13.4295C8.62017 13.2244 8.50513 12.9464 8.50513 12.6566C8.50513 12.3667 8.62017 12.0888 8.825 11.8837C9.03436 11.6814 9.3141 11.5684 9.60521 11.5684C9.89632 11.5684 10.176 11.6814 10.3854 11.8837L16.2187 17.5858C16.4236 17.7908 16.5386 18.0688 16.5386 18.3587C16.5386 18.6485 16.4236 18.9265 16.2187 19.1316C16.1121 19.2334 15.9863 19.313 15.8486 19.3655C15.7108 19.4181 15.564 19.4427 15.4167 19.4378Z'
                fill='#7950F2'
              />
              <path
                d='M9.58335 19.4373C9.43743 19.4383 9.29275 19.4104 9.15761 19.3554C9.02247 19.3003 8.89953 19.2191 8.79585 19.1164C8.59103 18.9113 8.47598 18.6333 8.47598 18.3435C8.47598 18.0537 8.59103 17.7757 8.79585 17.5706L14.6292 11.8685C14.7218 11.7335 14.8435 11.621 14.9854 11.5394C15.1273 11.4577 15.2857 11.4089 15.449 11.3966C15.6122 11.3844 15.7761 11.4089 15.9287 11.4684C16.0812 11.5279 16.2184 11.6209 16.3302 11.7405C16.4419 11.8601 16.5254 12.0033 16.5745 12.1594C16.6236 12.3156 16.637 12.4808 16.6137 12.6429C16.5904 12.8049 16.531 12.9597 16.44 13.0957C16.3489 13.2318 16.2285 13.3456 16.0875 13.4289L10.2542 19.131C10.0714 19.3057 9.83506 19.4136 9.58335 19.4373Z'
                fill='#7950F2'
              />
            </svg>

            <div className='help-detail'>
              <h6>Need more help?</h6>
              <p>
                We're here for you, contact your account manager or send an email to
                info@cellcast.com.au
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NewPurchaseCreditModal
